import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './components/Landing/Landing';
import ApplicationForm from './components/ApplicationForm/ApplicationForm';
import Academy from './components/Academy/Academy';
import Exam from './components/Exam/Exam';
import Result from './components/Result/Result';
import NotFound from './components/shared/NotFound';
import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Público — Flujo del postulante */}
        <Route path="/" element={<Landing />} />
        <Route path="/postula" element={<ApplicationForm />} />
        <Route path="/academia/:accessCode" element={<Academy />} />
        <Route path="/examen/:accessCode" element={<Exam />} />
        <Route path="/resultado/:recruitmentId" element={<Result />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
